<template>
  <div class="scs-binary-input">
    <h5>{{ heading }}</h5>
    <div class="binary-input">
      <h5 class="binary-input-option">
        {{ formatter ? formatter(option1) : option1 }}
      </h5>
      <div class="toggle-switch" @click="toggle">
        <div
          :class="
            selected === option1
              ? 'toggle-switch-indicator left'
              : 'toggle-switch-indicator right'
          "
        ></div>
      </div>
      <h5 class="binary-input-option">
        {{ formatter ? formatter(option2) : option2 }}
      </h5>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    toggle() {
      let selection =
        this.selected === this.option1 ? this.option2 : this.option1;
      this.$emit("toggle", selection);
    },
  },
  created() {},
  components: {},
  emits: ["toggle"],
  props: ["heading", "option1", "option2", "selected", "formatter"],
};
</script>
<style scoped>
.binary-input {
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-switch {
  margin: 10px;
  border: 1px solid var(--secondaryColor);
  height: 25px;
  width: 50px;
  min-width: 50px;
  border-radius: 15px;
  display: flex;
  box-shadow: inset 0px 0px 4px var(--shadow);
  cursor: pointer;
}

.toggle-switch-indicator {
  height: 17px;
  width: 17px;
  border-radius: 10px;
  margin: auto 5px;
  background-color: var(--contrastColor);
  transition: margin 1s;
}
h5 {
  margin: 5px;
}

.toggle-switch-indicator:hover {
  filter: drop-shadow(0 0 3px var(--shadow));
}

.left {
  margin-right: auto;
}

.right {
  margin-left: auto;
}
</style>
